import { createUseStyles } from 'react-jss';
import { color, fontSize, radius, spacing } from '@blink/components';

export const useManageItemStyle = createUseStyles({
    content: {
        display: 'flex',
        justifyContent: 'center',
        gap: spacing['07'],
        padding: spacing['05'],
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        borderRadius: radius.xs,
        border: `1px solid ${color.border.opaque}`,
    },
    header: {
        display: 'flex',
        padding: `${spacing['08']} 10% 0px`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    heading: {
        display: 'flex',
        padding: `${spacing['06']} ${spacing['05']}`,
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: spacing['02'],
    },
    titleText: {
        color: color.content.primary,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '40px',
        letterSpacing: '-0.64px',
    },
    top: {
        display: 'flex',
        padding: `0px 10% ${spacing['10']}`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    main: {
        display: 'flex',
        alignSelf: 'stretch',
        gap: spacing['06'],
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0',
    },
    description: {
        color: color.content.secondary,
    },
    card: {
        display: 'flex',
        padding: spacing['03'],
        width: '100%',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        borderRadius: radius.overall,
        border: `1px solid ${color.border.opaque}`,
        background: color.background.primary,
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.06)',
        '&:active': {
            border: `2px solid ${color.border.accent}`,
        },
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0',
    },
    cell: {
        display: 'flex',
        padding: spacing['05'],
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: spacing['03'],
        alignSelf: 'stretch',
        '& img': {
            width: 24,
            height: 24,
        },
    },
    row: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        color: color.content.primary,
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '-0.48px',
    },
    label: {
        color: color.content.fourth,
        fontSize: fontSize.md,
        lineHeight: '20px',
        letterSpacing: '-0.42px',
    },
    badge: {
        display: 'flex',
        minWidth: '20px',
        minHeight: '20px',
        padding: '2px 4px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: radius.overall,
        fontSize: 10,
        fontWeight: 600,
        lineHeight: '14px',
        letterSpacing: '-0.3px',
    },
    badgeNew: {
        background: color.background.lightAccent,
        color: color.content.accent,
    },
    badgeActive: {
        background: color.background.lightPositive,
        color: color.content.positive,
    },
    badgeSuspended: {
        background: color.background.lightNegative,
        color: color.content.negative,
    },
});
